export default __webpack_public_path__ + "fb02590386f4364ccc26322f070ec6c4.png";